import React from 'react';
import Chart from "react-apexcharts";
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'; 
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import * as helpers from '../../utils/helpers'; 

interface MetricCardProps {
    title: string;
    value: number;
    type: string; 
    icon: React.ReactElement;
    series?: {
      seriesData: number[];
      categories: string[];
    }
    handleClick?: () => void;
    shortValue?: boolean; 
    toolTipText?: string;  
  }
  
  interface TrendMetricCardProps extends MetricCardProps {
    trend: number;
  }

const TrendMetricCard: React.FC<TrendMetricCardProps> = ({ title, value, type, trend, icon, series, handleClick, toolTipText, shortValue }) => {
  const prefix = type === 'money' ? '$' : ''; 
    const trendIcon = trend > 0 ? <ArrowUpOutlined style={{ color: 'green' }} /> : <ArrowDownOutlined style={{ color: 'red' }} />;
    const options: ApexCharts.ApexOptions = series ? {
      chart: {
        type: 'line',
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        width: 2,
        curve: 'smooth'
      },
      xaxis: {
        categories: series.categories,
        crosshairs: {
          width: 1
        },
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return '';
            }
          }
        },
        marker: {
          show: false
        }
      }
    } : {};

    const renderIcon = () => {
      if(toolTipText)
        return (
          <OverlayTrigger
                key="overlayTrigger"
                placement="top"                                                            
                overlay={
                    <Tooltip className="my-tooltip2" id="af-tooltip">{toolTipText}</Tooltip>
                }              
            >{icon}</OverlayTrigger>
      ); 
      return (
        <>{icon}</>
      ); 
    }
  
    return (
      <Card 
        className="metric-card"
        style={{cursor: handleClick ? "pointer" : ""}}
        onClick={handleClick}
      >
        <Card.Title>
          <div className="metric-icon">          
            {renderIcon()}
          </div>   
          <div className="metric-title">{title}</div>
        </Card.Title>
        <Card.Body>
          <div className="metric-value">{shortValue ? helpers.nFormatter(value, 1, prefix) : prefix + value}</div>
          <div className="metric-trend">
            {trendIcon} {trend}%
          </div>
          {series && 
            <div className="metric-chart">
              <Chart options={options} series={[{ data: series.seriesData }]} type="line" height={60} />
            </div>
          }
        </Card.Body>
      </Card>
    );
  };

  export default TrendMetricCard; 